<template>
<div class="relative">
	<div class="fixed white" style="width: 100%;" id="tool-bar">
	<v-row style="width:100%" class="ma-0">
		<v-col cols="auto" class="d-flex flex-column pe-0">
			<slot name="breadcrumbs" :item="true" class="journal-breadcrumbs"></slot>
		</v-col>
		<v-col
			cols="auto"
			md="auto"
			style="width: auto !important;"
			class="d-flex align-center justify-start"
			>
			<bee-bond-up-down
				v-model="bond_no"
				:items="simplified_bonds.map(c=>c.bond_no)"
				class="medium-placeholder"
				:label="$t('CashJournalPage.bond-number')"
				:disabled="loading || !simplified_bonds.length"
				@keydown-enter-prevent="changeRoute()"
				@programmatically-changed="changeRoute()"
			/>
		</v-col>
		<v-col cols="auto" class="d-flex align-center">
			<bee-btn
			context="bond"
			:action-name="actions.CREATE"
			icon="fa-plus"
			:disabled="file_is_locked || (loading && !createLoading)"
			@click="create_bonds_manually ? addBondDialog = true : addBond()"
			:content="$t('CashJournalPage.new')"
			color="addingColor"
			:loading="createLoading"
			/>
			<!--delete-->
			<bee-btn
				v-if="!bond.invoice_id && !file_is_locked && !bond.is_posted && bond.id && !hideDeleteButton"
				context="account"
				:action-name="actions.DELETE"
				:content="$t('AccountingJournalPage.delete')"
				icon="fa-trash-alt"
				color="deletingColor"
				outer-class="ms-4"
				:disabled="loading"
				@click="deleteDialog = true"
			></bee-btn>		
		</v-col>
		<v-spacer></v-spacer>
		<v-col v-if="true" sm="auto" xs="12" cols="auto" class="d-flex align-center">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attr }">
					<div v-on="on" v-bind="attr" class="d-flex align-center">
						<!-- <v-switch
							@change="reverseCurrency(!reverseCurrencyPrice)"
							class="rounded-lg mt-0"
							dense
							hide-details
							inset
							label="الحساب العكسي"
							>
						</v-switch> -->
						<v-btn
							class=" rounded-lg pa-0 greyDarken2--text"
							text
							style="border:2px solid rgb(230,200,20)"
							@click="reverseCurrency(!reverseCurrencyPrice)"
						>
							<div
								class="rounded-lg"
								style="background:rgb(230,200,20); padding: 6px 0"
								:class="`rounded-${$i18n.locale !== 'ar' ? 'r' : 'l'}-0`"
							>
								<v-icon
									class="rounded-lg mx-2"
									color="white"
								>
									mdi-swap-vertical
								</v-icon>
							</div>
							<div
								class="d-flex flex-column align-center justify-center relative  mx-3 rounded-lg"
								:class="`rounded-${$i18n.locale !== 'ar' ? 'l' : 'r'}-0`"
							>
								<span class="absolute fw-bold" style='top:-50%; left:-20%;'>
									<v-icon class="mb-1 ms-2" v-if="reverseCurrencyPrice" size="8px">
										fa-money-bill-wave
									</v-icon>
									<v-icon  v-else size="10px">
										fa-coins
									</v-icon>
								</span>
								<span class="absolute" style='top:30%; left:70%;' >
									<v-icon v-if="!reverseCurrencyPrice" size="8px">
										fa-money-bill-wave
									</v-icon>
									<v-icon v-else size="10px">
										fa-coins
									</v-icon>
								</span>
								<v-icon class="" small>
									mdi-slash-forward
								</v-icon>
							</div>
						</v-btn>
					</div>
				</template>
					<span>{{$t('AccountingJournalPage.reverse-currency-price')}}</span>
			</v-tooltip>
		</v-col>
		<v-col v-if="userType !== userPermission.treasurer" lg="auto" md="auto" cols="auto" sm="auto" xs="12" class="d-flex align-center">

			<bee-btn
				@click="createAccount()"
				:disabled="file_is_locked"
				color="addingColor"
				:content="$t('CashJournalPage.add')"
				icon="fa-user-plus"
				context="account"
				:action-name="actions.CREATE"
			></bee-btn>
			<bee-btn  
				:content="$t('CashJournalPage.cash-statement') + (main_box.name ? ` (${main_box.name})` : '')"
				color="editingColor"
				icon="far fa-share-square fa-rotate-180"
				@click="statementAccount()"
				outer-class="ms-3"
				context="statement"
				:action-name="actions.GET"
			></bee-btn>
		</v-col>
	</v-row>
    <v-row style="width: 100%" class="ma-0" align="center">


		<v-col cols="auto" lg="auto" sm="12" md="auto" class="flex-grow-1 d-flex pt-0">
		<v-layout wrap class="d-flex flex-row my-border rounded-lg">
				<v-col cols="auto" class="d-flex align-center">
					<bee-date-picker
						v-model="bondData.date"
						:disabled="bond.is_posted || file_is_locked || loading"
						context="bond"
						:action-name="actions.EDIT"
						:label="$t('inputs.bond-date')"
						:rules="[
							rules.date,
							canAddFutureDate 
								? true 
								:v => moment(v).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || false 
						]"
						:hide-details="true"
						@blur="updateBond()"
					></bee-date-picker>
				</v-col>
				<v-col v-if="useBondNotes" cols="12" sm="4" md="3" lg="3" class="d-flex align-center">
                    <v-text-field
                    	v-model="bondData.notes"
                    	:disabled="this.bond?.is_posted || loading"
                    	:label="$t('inputs.notes')"
                    	outlined
                    	dense
                    	hide-details
                    	@change="updateBond();"
                    />
                </v-col>
				<v-col></v-col>
				<v-col cols="auto" sm="auto" xs="12" md="auto" lg="auto" class="d-flex align-center">
					<bee-btn
						v-if="
							useUnPostingPermission
								? (!bond.is_posted || (bond.is_posted && canUnPost))
								: true
						"
					    context="bond"
					    :action-name="actions.EDIT"
					    :content="on_lgAndUp ?
							bond.is_posted ? $t('CashJournalPage.edit') : $t('CashJournalPage.save')
							: ''
						"
					    :icon="bond.is_posted ? 'fa-envelope-open' : 'fa-envelope'"
					    :outer-class="on_lgAndUp ? 'text-wrap' : ''" 
					    :disabled="file_is_locked || (loading && !updateBondLoading)"
					    :loading="updateBondLoading"
					    :color="bond.is_posted ? 'deletingColor' : 'blueGray'"
					    @click="bond.is_posted ? unPosting() : posting()"
					></bee-btn>
				</v-col>
				<v-col v-if="useBondAuditLogs" cols="auto" class="d-flex align-center px-0">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attr }">
							<v-btn
								small
								depressed
								color="transparent"
								:disabled="loading"
								@click="infoDialog = true"
								v-on="on"
								v-bind="attr"
							>
							<v-icon>mdi-information-outline</v-icon>
							</v-btn>
						</template>
						<span>{{ $t('invoice-info') }}</span>
					</v-tooltip>
				</v-col>

				<v-col cols="auto" class="d-flex align-center py-0 pe-lg-0 justify-md-end my-0">
					<bee-outlined-header-info
					    :head="on_lgAndUp
							? $t('CashJournalPage.posted-journals-balance')
							: $t('CashJournalPage.posted-journals-balance') + ':' "
					    border-color="transparent"
					    class="px-lg-0"
					    :column="on_lgAndUp"
					>
						<template  v-slot:content="{}">
							<bee-advanced-money-label :currencies="configs.currencies" v-model="box_balance" :withColor="true" empty-state="_"></bee-advanced-money-label>
						</template>
					</bee-outlined-header-info>
				</v-col>

				<v-col cols="auto" class="d-flex justify-lg-end py-1">
					<router-link style="text-decoration: none;" :to="{name: 'journals'}">
						<bee-progress-circular
							:tooltip="bond_posting_ratio_tooltip"
							:size="60"
							:width="6"
							:value="bond_posting_ratio"
							:title="bond_posting_ratio_caption"
							class="text-caption"
						>
						{{ bond_posting_ratio_caption }}
						</bee-progress-circular>
					</router-link>
				</v-col>
				<v-col lg="1" md="12" sm="12" xs="12" cols="12" 
                    :class="[
						bond.is_posted ? 'postedColor': 'unpostedColor',
						on_lgAndUp ? 'border-round-end' : 'border-round-bottom'
					]"
                    :style="on_lgAndUp ? 'height: 100%; ' : ''" 
                    style="border-color: transparent !important;  align-items: center !important;" 
                    class="justify-content-center justify-center flex-grow-1 d-flex white--text my-border text--title text-center align-center font-weight-bold text-wrap">
					<span class="text-center align-center" style="line-height: 1.2;">
						{{bond.is_posted ? '' : $t('CashJournalPage.not')}}
					<br v-if="!bond.is_posted">{{$t('CashJournalPage.posted')}}</span>
				</v-col>
		</v-layout>
		</v-col>
    </v-row>
	</div>
	<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
    <v-card flat>
		<v-card-text class="py-0 px-3">
			<!-- <bee-smart-table v-if="false" max-height="45vh" mode="funds" context="entry" 
			 	:action-name="actions.CREATE" ref="table" :with-color="false" 
				:zebra="true" 
				empty-state="dashes" 
				:hide-footer="true"
				@cell-change="entries[$event.index][$event.header.value] = $event.value"
				:addable="addable && !file_is_locked" 
				:editable="!bond.is_posted && !file_is_locked" 
				@reset-data="fetchEntry($event)" 
				:headers="headers"
				:items="entries"
				:show-menu-actions="true"
				@row-edited="updateEntry($event)"
				@row-added="addEntry($event)" 
				@delete-item="deleteEntry($event)"
				@account-statement="goToAccountStatement($event)"
				highlighted-color="blueGray lighten-3"
				:highlighted-expression="(item)=>{ return item.id == $route.query.entryId || item.linked_entry_id == $route.query.entryId }" 
				:right-click-menu-items="actionsList"
				:configs="custom_configs"
				:messagesSelectRowValidation="messagesSelectRowValidation"
				@nblur="handlBlurBoundTable">
			</bee-smart-table> -->
			<bee-handy-smart-table
				v-if="true"
				v-model="tableInputs"
				ref="table"
				:height="$vuetify.breakpoint.height - 370"
				:headers="headers"
				zebra
				:items="entries"
				dense
				fixed-header
				pagination-on-scroll
				:shown-rows-text="$t('shown-rows-text')"
				stay-in-input-fields
				:data-table-props="{
					disableSort: true
				}"
				:loading="loading"
				:row-highlight-expression="(item) => item.id === Number($route.query.entryId)"
				:scroll-to-row-expression="(item) => item.id === Number($route.query.entryId) || item.id === entryId || item.id === entries[entries.length - 1]?.id"
				:context-menu-items="contextmenuItems"
				:show-add-row="!bond.is_posted && !file_is_locked && !updateBondLoading && !isViewer && Boolean($route.params.id)"
				:editable-rows="!bond.is_posted && !file_is_locked && !updateBondLoading && !isViewer"
				hide-no-data-area
				hide-inputs-details="auto"
				with-columns-divider
				hot-inputs="lazy"
				:hot-inputs-order="['currency-price']"
				:validation-messages.sync="validationMessages"
				:disable-input-fields="loading"
				:disable-context-menu="loading || isViewer"
				disable-mobile-context-menu
				@keypress.enter="entryHandler"
				@context-menu-account-statement="openAccountStatement"
				@context-menu-edit="({ item }) => {entryId = item.id; reverseCurrencyPriceInputValue()}"
				@reached-last-input="entryHandler"
				@context-menu-delete="({ item }) => { deleteEntryId = item.id; dialogDeleteCashEntry = true}"
				@edit-cancelled="
					entryId = null; 
				"
				@change-currency="tableInputs['currency-price'] = getCurrencyById(tableInputs.currency)?.latest_exchange_record 
				? (reverseCurrencyPrice 
							? 1 / getCurrencyById(tableInputs.currency)?.latest_exchange_record 
							: getCurrencyById(tableInputs.currency)?.latest_exchange_record
					) 
				: null" 
				@dblclick:row="(e, { item }) => { 
					bond.is_posted 
					? openAccountStatement({ item })
					: null
				}"
			>
				<!-- account -->
				<template v-slot:input.account="{ on, attr }">
					<v-autocomplete
						v-on="on"
						v-bind="attr"
						:items="configs.accounts.filter(c => c.type === 2)"
						item-value="id"
						:item-text="item => item.accounting_no + '-'+ item.name"
						auto-select-first
					>
						<template v-slot:selection="{ item }">
							{{ item.accounting_no +'-'+ item.name }}
						</template>
						<template v-slot:item="{ item }">
							{{ item.accounting_no + '-'+ item.name }}
							<v-spacer></v-spacer>
							<bee-advanced-money-label
								v-if="userType !== userPermission.treasurer"
								:with-color="true"
								:value="item?.account_statement_summary"
								:show-zeros-values="true"
							></bee-advanced-money-label>
						</template>
					</v-autocomplete>
				</template>

				<!-- currency -->
				<template v-slot:input.currency="{ on, attr }">
					<v-autocomplete
						v-on="on"
						v-bind="attr"
						:items="[{ id: null, symbol: null }, ...configs.currencies.filter(v => v.id !== currentFinancialFile?.default_currency_id)
						]"
						item-value="id"
						item-text="symbol"
					>
						<template v-slot:item="{ item }">
							{{item.id ? item.symbol : $t('inputs.undefined')}}
						</template>
					</v-autocomplete>
				</template>

				<!-- order inside bond -->
				<template v-slot:no-input.order-inside-bond="{ item }">
					<span class="font-weight-bold">{{item ? item.order_inside_bond : null}}</span>
				</template>
				<template v-if="showDateEntryColumn"  v-slot:input.date="{ on, attr }">
					<bee-date-field
						v-bind="attr"
						v-on="on"
						dense
					></bee-date-field>
				</template>
				<!-- hint -->
				<template v-slot:no-input.hint>
					<div v-if="validationMessages.length > 0" class="text-center">
						<v-menu bottom >
							<template v-slot:activator="{ on, attr }">
								<v-icon
									v-on="on"
									v-bind="attr"
									color="danger-color"
									size="20"
								>mdi-information</v-icon>
							</template>

							<v-list>
								<v-list-item
									v-for="(message, i) in inputsValidationMessages"
									:key="i"
									dense
									class="px-2"
								>
									<v-list-item-icon class="me-0 mb-0">
										<v-icon color="danger-color" x-small>mdi-circle-half</v-icon>
									</v-list-item-icon>
									<v-list-item-title class="danger-color--text">
										{{message}}
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
					<!-- focus handler to avoid focusing out side the page-->
					<v-btn v-else text plain retain-focus-on-click min-width="1px" height="1px" class="pa-0" @keydown.tab.prevent>
					</v-btn>
				</template>
				<template v-slot:item.hint="{ item, index }">
					<div class="d-flex text-center">
						<v-tooltip bottom v-if="bond.is_posted && useExportPaymentReceiptBond">
							<template v-slot:activator="{ on, attr}">
								<v-btn
									v-on="on"
									v-bind="attr"
									small
									icon
									@click="paymentReceiptBond(item)"
								>
									<v-icon class="primary--text" size="22">
										mdi-invoice-import-outline
									</v-icon>
								</v-btn>
							</template>
							<span>
								{{ 
									item.debit ? $t('CashJournalPage.export-payment-bond') : $t('CashJournalPage.export-repayment-bond')
								}}
							</span>
						</v-tooltip>
						<v-menu offset-y> 
							<template v-slot:activator="{ on, attr }">
								<v-btn
									v-bind="attr"
									v-on="on"
									class="mx-1"
									small
									icon
									width="32"
								>
									<v-icon>
										mdi-dots-vertical
									</v-icon>
								</v-btn>
							</template>
							<v-list dense>
								<v-list-item v-if="userType !== userPermission.treasurer" @click="openAccountStatement({ item })">
									<v-list-item-content class="pa-0">
										{{ $t('AccountingJournalPage.context-menu.account-statement') }}
									</v-list-item-content>
								</v-list-item>
								<v-list-item 
									@click="$refs.table.activeEditForRow(index); entryId = item.id;reverseCurrencyPriceInputValue();"
									
									:disabled="bond.is_posted || file_is_locked"
								>
									<v-list-item-content class="pa-0">
										{{ $t('AccountingJournalPage.context-menu.edit') }}
									</v-list-item-content>
								</v-list-item>
								<v-list-item 
									@click="deleteEntryId = item.id; dialogDeleteCashEntry = true"
									:disabled="bond.is_posted || file_is_locked"
								>
									<v-list-item-content class="pa-0">
										{{ $t('AccountingJournalPage.context-menu.delete') }}
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</template>
			</bee-handy-smart-table>
		</v-card-text>
    </v-card>
	<bee-dialog
	    @handler="confirmDeleteEntry(); $emit('close')"
	    @close="dialogDeleteCashEntry = false"
	    v-model="dialogDeleteCashEntry"
	    :title="$t('CashJournalPage.delete-cash-entry')"
	    :message="$t('CashJournalPage.are-you-sure-you-want-delete-the-entry')"
	></bee-dialog>
	<!--dialog delete bond-->
	<v-dialog v-model="deleteDialog" width="450px">
		<v-card>
			<v-card-title>
				{{$t('bonds.delete-bond')}}
			</v-card-title>
			
			<v-card-text class="py-2">
				{{$t('bonds.delete-bond-confirm')}}
			</v-card-text>

			<v-card-actions>
				<v-btn text color="success-color" @click="[deleteDialog = false,DeleteBond()]">{{$t('buttons.ok')}}</v-btn>
				<v-btn text color="danger-dark-color" @click="deleteDialog = false">
					{{$t('buttons.cancel')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
    <v-dialog v-model="addBondDialog" max-width="500" transition="dialog-top-transition">
		<v-form ref="bondForm" v-model="valid" @submit.prevent="addBond()">
			<v-card>
				<v-card-title class="headline">
					{{$t('CashJournalPage.add-bond')}}
				</v-card-title>
				<v-card-text>
					<bee-date-picker
						context="bond"
						:action-name="actions.CREATE"
						:label="$t('CashJournalPage.bond-date')"
						v-model="bond_date"
						:rules="[
							rules.date,
							canAddFutureDate 
								? true
								: v => moment(v).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || false
						]"
					></bee-date-picker>
					<v-text-field 
					v-model="bond_notes"
					class="mx-3"
					:label="$t('inputs.notes')"
					outlined
					dense
					hide-details
					/>
				</v-card-text>
				<v-card-actions class="ms-3">
					<v-btn type="submit" color="greenDarken1" text :loading="loading" :disabled="!valid">
						{{$t('CashJournalPage.create')}}
					</v-btn>
					<v-btn color="redDarken1" text @click="addBondDialog = false">
						{{$t('CashJournalPage.cancel')}}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-form>
    </v-dialog>

	<!-- the code of the info dialog goes here -->
	<v-dialog
		v-model="infoDialog"
		max-width="550"
		content-class="rounded-xl"
		persistent
	>
		<v-card
			class="rounded-xl"
		>
			<v-card-title class="rounded-xl">{{ $t('invoice-info') }}</v-card-title>
			<v-card-text class="pb-1">
				<bee-handy-table
					:headers="infoHeaders"
					:items="cashBond.audit_log_simplified_responses ? cashBond.audit_log_simplified_responses : [] "
					pagination-on-scroll
					shown-rows-text=""
					fixed-header
					dense
					elevation="1"
					zebra
				>
					<template v-slot:item.type="{ item }">
						<span  
						:class="
								item.type === actionType.create ? 'green--text'
								: item.type === actionType.post ? 'blue--text' 
								: item.type === actionType.unPost ? 'warning--text' 
								: null"
						>
							{{ actionTypes.find(c => c.type === item.type)?.name }}
							<!-- {{
								actionTypes
									.slice()
									.sort((a, b) => new Date(a.date) - new Date(b.date))
									.find(c => c.type === item.type)?.name
							}} -->
						</span>

					</template>
					<template v-slot:item.date="{ item }">
						<div dir="auto" class="d-flex justify-end">
                            {{ moment(item.date_formatted).locale('en').format('h:mm:ss A ,YYYY-MM-DD') }}
                        </div>
					</template>
				</bee-handy-table>
			</v-card-text>
			<v-card-actions class="rounded-xl">
				<v-btn 
					color="transparent grey--text"
					smal
					depressed
					@click="infoDialog = false"
					>
					<span>{{ $t('close') }}</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-footer id="footer" fixed app horizontal class="px-3">
		<div class="d-flex justify-space-between py-3" style="width: 100%;">
			<v-row class="d-flex justify-space-between">
				<v-col cols="12" sm="4" lg="auto">
					<div class="d-flex">
						<span class="text-caption">{{$t('CashJournalPage.footer.total')}}</span>
						<div class="d-flex justify-center mr-2">
							<v-card
							  class="custom_debit_credit_styles d-flex align-center">
								
								<v-card-text
									:class="advancedColorMode ? 'red--text' : 'green--text'"
									class="pa-0 font-weight-bold d-flex justify-center">
									{{ sum_debits ? sum_debits.amount.toLocaleString('en') : '' }}
								</v-card-text>
							</v-card>
							<v-card
								class="custom_debit_credit_styles d-flex align-center"
							  >
								<v-card-text 
									:class="advancedColorMode ? 'green--text' : 'red--text'"
									class="pa-2 font-weight-bold d-flex justify-center"
									>
									{{ sum_credits ? sum_credits.amount.toLocaleString('en') : '' }}
								</v-card-text>
							</v-card>
							<v-card
							  :width="60"
							  class="d-flex justify-center align-center mr-3 text-body-2">
								{{ sum_difference ? getCurrencyById(sum_difference.currency_id).symbol : '' }}
							</v-card>
						</div>
					</div>
					<div class="d-flex justify-center mt-2">
						<span class="text-caption">{{$t('CashJournalPage.footer.difference')}}</span>
						<div class="d-flex justify-center mr-6">
							<v-card
								class="custom_sum_difference_styles d-flex align-center">
								<v-card-text
									:class="[ sum_difference ? (sum_difference.money_type === (advancedColorMode ? 1 : 0) ? 'red--text' : 'green--text') : '' ]"
									class="pa-2 font-weight-bold text-center">
									{{ sum_difference ? sum_difference.amount.toLocaleString('en') : '' }}
								</v-card-text>
							</v-card>
							<v-card
								:width="60"
								class="d-flex justify-center align-center mr-3 text-body-2"
							  >
							  {{ sum_difference ? getCurrencyById(sum_difference.currency_id).symbol : '' }}
							</v-card>
						</div>
					</div>

				</v-col>
				<v-col
				  cols="12"
				  sm="4"
				  lg="auto"
				  class="d-flex align-center custom_revolving_box">
					<div class="d-flex flex-column justify-center">
						<div class="mb-4" style="user-select: none; pointer-events: none;">
							<span class="text-caption border_text_revolving">{{$t('CashJournalPage.footer.revolved')}}</span>
						</div>
						<div class="d-flex">
							<v-card class="custom_revolvingBalance_sum_result_styles">
								<v-card-text
								  class="pa-1 font-weight-bold text-center"
								  :class="[revolvingBalance ? (revolvingBalance.sum_result.sum_difference.money_type === 1 ? 'red--text' : 'green--text') : '' ]"
								  >
								  {{ revolvingBalance ? revolvingBalance.sum_result.sum_difference.amount.toLocaleString('en') : '' }}
								</v-card-text>
							</v-card>
							<v-card
							  :width="60"
							  :height="30"
							  class="d-flex justify-center align-center mr-3 text-body-2"
							  :class="[revolvingBalance ? (revolvingBalance.sum_result.sum_difference.money_type === 1 ? 'red--text' : 'green--text') : '' ]">
							  {{ revolvingBalance ? getCurrencyById(revolvingBalance.sum_result.sum_difference.currency_id).symbol : '' }}
							</v-card>
						</div>
					</div>
					<div>
						<v-card :width="140" :height="74" class=" d-flex align-center custom_2">
							<v-card-text class="pa-1 d-flex justify-center">
								<div class="d-flex flex-column">
									<span
										v-for="(item, index) in revolvingBalance ? revolvingBalance.sum_currencies_result.currencies_sum_difference : []"
										:key="index"
										:class="[item ? (item.amount < 0 ? 'red--text' : 'green--text') : '']"
									>
										{{ item.amount.toLocaleString('en') }}
										{{ getCurrencyById(item.currency_id).symbol }}
									</span>
								</div>
							</v-card-text>
						</v-card>
					</div>
				</v-col>
				<v-col cols="12" sm="4" lg="auto" class="custom_1">
					<div class="d-flex justify-space-between my-auto">
						<!-- <div>
							<v-card :width="140" :height="74" class=" d-flex align-center custom_2" style="background-color: blue">
								<v-card-text class="pa-1 d-flex justify-center">
									<div class="d-flex flex-column">
										<span
											v-for="(item, index) in revolvingBalance ? revolvingBalance.sum_currencies_result.currencies_sum_difference : []"
											:key="index"
											:class="[item ? (item.amount < 0 ? 'red--text' : 'green--text') : '']"
										>
											{{ item.amount.toLocaleString('en') }}
											{{ getCurrencyById(item.currency_id).symbol }}
										</span>
									</div>
								</v-card-text>
							</v-card>
						</div> -->
						<div class="d-flex custom_currencies_maring">
							<v-card :width="140" :height="74" class="d-flex align-center">
								<v-card-text class="pa-1 d-flex justify-center">
									<div class="d-flex flex-column">
										<span
											v-for="(item, index) in currency_debits"
											:key="index"
											class="red--text"
										>
											{{ item.amount.toLocaleString('en') }}
											{{ getCurrencyById(item.currency_id).symbol }}
										</span>
									</div>
								</v-card-text>
							</v-card>
							<v-card :width="140" :height="74" class="d-flex align-center">
								<v-card-text class="pa-1 d-flex justify-center">
									<div class="d-flex flex-column">
										<span
											v-for="(item, index) in currency_credits"
											:key="index"
											class="green--text"
										>
											{{ item.amount.toLocaleString('en') }}
											{{ getCurrencyById(item.currency_id).symbol }}
										</span>
									</div>
								</v-card-text>
							</v-card>
						</div>
					</div>
				</v-col>
				<v-col cols="12" lg="auto">
					<div>
						<v-card :width="120" :height="74" class="d-flex align-center">
							<v-card-text class="pa-1 d-flex justify-center">
								<div class="d-flex flex-column">
									<span
										v-for="(item, index) in currencies_sum_difference"
										:key="index"
										:class="[item ? (item.amount < 0 ? 'red--text' : 'green--text') : '']"
									>
										{{ item.amount.toLocaleString('en') }}
										{{ getCurrencyById(item.currency_id).symbol }}
									</span>
								</div>
							</v-card-text>
						</v-card>
					</div>
				</v-col>
				<v-spacer></v-spacer>
				<v-col
					v-if="show_symbol_currencies && on_mdAndUp"
					cols="12" 
					sm="4" 
					lg="1"
					class="px-0 d-flex align-center"
				>
				</v-col>
			</v-row>
		</div>
	</v-footer>
	<account-form v-model="showAccountForm"></account-form>
    <bee-confirm-dialog
		@close="alertNoBoxAccountDialog = false; $router.push({name: 'default-accounts'})"
		v-model="alertNoBoxAccountDialog"
		:title="$t('CashJournalPage.warning')"
		:message="$t('CashJournalPage.No-fund-has-been-set-for-the-financial-file-yet')"
    ></bee-confirm-dialog>
	</div>
</div>
</template>
<script>
import rules from "../../../validation";
import { mapState, mapGetters } from "vuex";
import  store  from "../../../store/index.js";
import _ from 'lodash'
import EventBus from '../../../event-bus'
// import { refactorEntry } from "./helper/operations-calculated-properties.js";
// import { entryCashDetectedValidation } from "./helper/validation-detected-entry";
import AccountForm from './sub-components/AccountForm.vue';
import ls from '../../../settings/localStorageExtension';
import actions from "../../../permissions/actions-names.js"
import { bondType, actionTypes, actionType, userPermission, paymentReceiptBondType } from '@/helpers/enums';
import { useUnPostingPermission, useBondAuditLogs, useBondNotes } from '@/configs/global';
import moment from 'moment'
const openNewWindowForAccountStatement =
	JSON.parse(localStorage.getItem('openAccountStatementInNewWindow'));
export default {
components: { AccountForm },
data: () => ({
	alertNoBoxAccountDialog: false,
	entry: null,
	dialogDeleteCashEntry: false,
	actions,
	sum_difference_equivalent: { amount: null, currency_id: null, money_type: null},
	showAccountForm: false,
	show: false,
    bond_no: null,
    ...rules,
    addBondDialog: false,
    loading: false,
	items2: [],
	simplified_bond:{
		id: null,
		date: null,
		is_posted: null,
		bond_no: null,
		deleted_at: null,
	},
	tableInputs: {
	},
    bond_date: moment().format('YYYY-MM-DD'),
	messagesSelectRowValidation: [],
	linkedBoundRules: {
		debit: true,
		credit: true,
		currency_debit: true,
		currency_credit: true,
		currency_id: true,
    },
	updateBondLoading: false,
	revolvingBalance: null,
	cashBond: {},
	useUnPostingPermission,
	deleteLoading: false,
	deleteDialog: false,
	infoDialog: false,
	actionTypes,
	actionType,
	userPermission,
	moment,
	useBondAuditLogs,
	useBondNotes,
	bondData: {
		date: null,
		notes: null,
		id: null,
		type: bondType.cash
	},
	bond_notes: '',
	entryId: null,
	deleteEntryId: null,
	validationMessages: [],
	valid: true,
	reverseCurrencyPrice: false,
	saveNotes: null,
	createLoading: false
}),

methods: {
	test(v){console.log(v)},
	DeleteBond(){
			this.deleteLoading = true
			store.dispatch("bonds/delete", { bondId: this.bond.id, bondType: this.bond.type? bondType.accounting: bondType.cash   })
			.then(() => {
				let promises = [ 
					store.dispatch("configs/fetchAll"),
					store.dispatch("bonds/search", { bondId: this.bondId, type: this.type, status: this.status, fromDate: this.fromDate, toDate: this.toDate, dateSortMode: 2, bondTypeSortMode: 2 }),
					store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }),
					store.dispatch("bonds/fetchAll", { bondType: bondType.cash }).then(()=>{
						if(this.simplified_bonds.length){
							this.$router.replace({
							name:'cash-journal', 
							params:{id:this.simplified_bonds[this.simplified_bonds.length -1].id}})}
						else {
							this.$router.replace({name:'cash-journal'})
						}
					})
				]
				Promise.all(promises)
			})
			.finally(() => {this.deleteLoading = false ;});	
    },
	deleteEntry($event){
		this.entry = {...$event}
		this.dialogDeleteCashEntry = true
    },
	reverseCurrency() {
		this.reverseCurrencyPrice = !this.reverseCurrencyPrice;
		if(this.tableInputs['currency-price']) {
			this.tableInputs['currency-price'] = 1 / this.tableInputs['currency-price'];
		}
	},
	reverseCurrencyPriceInputValue() {
		if(this.tableInputs['currency-price'] && this.reverseCurrencyPrice) {
			this.tableInputs['currency-price'] = 1 / this.tableInputs['currency-price'];
		}
	},
    confirmDeleteEntry(){
		let bondId  = this.bond.id
        store.dispatch("bonds/deleteEntry", { bondId, bondType: bondType.cash, entryId: this.deleteEntryId }).then( ()=>{
			this.fetchBond(true)
		}).finally(()=>{this.deleteEntryId = null})
    },
    redirectToBond($event){
      console.log($event)
    },
    addBond() {
		if(this.valid) {
			this.loading = true;
			this.createLoading = true;
			store.dispatch("bonds/create",{ bondType: bondType.cash, date:this.bond_date, notes: this.bond_notes})
			.then(response => { 
				this.bondData.date= response.date;
				this.bondData.notes = response.notes;
				this.bond_no = response.bond_no 
				this.$router.push({ name: "cash-journal", params: { id: response.id } })
				// this.$refs.table.endLineInputValues = {date: new Date().toISOString()}
				// this.$refs.table.onEsc()
				store.dispatch("configs/fetchAll")
			})
			.finally(() => {
				this.loading = false;
				this.createLoading = false;
			});
			this.addBondDialog = false
			this.bond_date = moment().format('YYYY-MM-DD')
		} 
    },
	updateBond() {
		/*temporary solved until find a solution to date picker validation*/
		if(moment(this.bondData.date).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || this.canAddFutureDate) {
			this.$store.dispatch('bonds/update', {
				bondId: this.bond.id,
				bondType: this.bondData.type,
				date: this.bondData.date,
				notes: this.bondData.notes
			})
			.then(() => {
				this.fetchBond(true);
				EventBus.$emit("notification", "تم تحديث بيانات السند");
			})
		}
	},
	/* eslint-disable */
	fetchBond(isUpdate = false){
		const bond = this.simplified_bonds?.find(c=>c.id == this.$route.params.id)
		if(bond){
			// !isUpdate ? this.$router.push({name: 'cash-journal', params:{id: bond.id}}) : null
			this.loading = true;
			// this.$refs.table.openLoading();
			return store.dispatch("bonds/fetch", {bondId: Number(this.$route.params.id), bondType: bondType.cash })
				.then(response=> {
					this.cashBond = response;
					store.dispatch('statements/fetchBoxBalanceByNo', { bondNo: this.bond_no }).then((data) => {
						this.revolvingBalance = data.data
					})
					this.bond_no = response.bond_no;
					this.bondData.date = response.date;
					this.bondData.notes = response.notes;
					store.dispatch("statements/fetchBoxBalance")
					store.dispatch("accounts/getMainBox")
					// this.$refs.table.endLineInputValues = {date: new Date().toISOString()},
					// this.$refs.table.onEsc(),
					// this.$refs.table.closeLoading();
					this.loading = false;
					this.updateBondLoading = false
					if(!response.is_posted) {
						this.saveNotes = response.entries[response.entries.length ? response.entries.length - 1 : 0 ]?.note;
					}
					if (!isUpdate) {
						this.$refs.table.resetEdit();
						this.$nextTick(() => {
							this.$refs.table.scrollToRow();
							this.$refs.table.scrollToRow();
							if(!response.is_posted) {
								setTimeout(() => {
									this.$refs.table.resetInputs({
										/*important to keep the date input has value */
										date: moment(this.bondData.date).format('YYYY-MM-DD'),
										note:this.saveNotes
									});
									this.$refs.table.resetInputsFocus();
								})
							}
						});
					}
				})
		} else {
			
		}
    },
	fetchBondByNo(bondNo){
		if(bondNo){
		// this.$refs.table.openLoading()
			store.dispatch("bonds/fetchBondByNumber", { bondType: bondType.cash, bondNo: bondNo })
				.then(()=> { 
					store.dispatch("statements/fetchBoxBalance")
					// this.$refs.table.endLineInputValues = {date: new Date().toISOString()}, 
					// this.$refs.table.onEsc()
					// // this.$refs.table.closeLoading()
				})
		}
    },
	/* eslint-disable */
    // updateEntry(object){
	// 	var entry  = refactorEntry(this.entries[object.rowIndex], this.configs.financial_file.default_currency_id)
	// 	entry.bond_id = this.bond.id
	// 	delete entry.currency_id
	// 	entry.date =this.bondData.date;
	// 	if(this.$refs.table.$refs.table.$refs.table.valids[`valid_${object.rowIndex}`])
	// 	{
	// 		this.loading = true;
	// 		store.dispatch("bonds/updateEntry", {
	// 			bondId: this.bond.id,
	// 			bondType: bondType.cash,
	// 			entry
	// 		})
	// 		.then(() => { 
	// 			this.loading = false;
	// 			object.deleteRowIndex();
	// 			this.fetchBond(true);
	// 		})
	// 		.finally(()=>{
	// 			// this.$refs.table.loading = false;
	// 			this.loading = false;
	// 			this.$nextTick(() => {
	// 				// this.$refs.table.$refs[`input_1`][0].$children[0].$refs.BeeNumericField.focus();
	// 			})
	// 		})
	// 	} else {
	// 		EventBus.$emit('error', this.$t('CashJournalPage.make-sure-the-data-entered-is-correct'))
	// 	}
	// 	},
    entryHandler(){
		if(this.$refs.table.validate()) {
			this.loading = true;
			const actionName = this.entryId ? 'updateEntry' : 'createEntry'
			store.dispatch(`bonds/${actionName}`, {
				bondId: this.bond.id,
				bondType: bondType.cash,
				entry: {
					id: this.entryId,
					account_id: this.tableInputs.account,
					bond_id: this.bond.id,
					debit: this.tableInputs.debit ? {
						amount: this.tableInputs.debit,
						currency_id: this.currentFinancialFile.default_currency_id
					} : null,
					credit: this.tableInputs.credit ? {
						amount: this.tableInputs.credit,
						currency_id: this.currentFinancialFile.default_currency_id
					} : null,
					currency_debit: this.tableInputs['currency-debit'] ? {
						amount: this.tableInputs['currency-debit'],
						currency_id: this.tableInputs.currency
					} : null,
					currency_credit: this.tableInputs['currency-credit'] ? {
						amount: this.tableInputs['currency-credit'],
						currency_id: this.tableInputs.currency
					} : null,
					currency_price: this.reverseCurrencyPrice && this.tableInputs['currency-price']
							? 1 / this.tableInputs['currency-price'] 
							:this.tableInputs['currency-price'],
					date: this.showDateEntryColumn? this.tableInputs.date : this.bondData.date,
					note: this.tableInputs.note,
					// date: this.tableInputs.date.slice(0, 10),
					paper_document_no: this.tableInputs['paper-document-no'],
				}
			})
			.then(() => {
				this.fetchBond(true).then(() => {
					const initTable = () => {
						const savedNotes = this.saveNotes;
						this.$nextTick(() => {
							this.$refs.table.scrollToRow();
							this.$refs.table.scrollToRow();
							this.$refs.table.resetInputs({
								note: savedNotes,
								date: 	moment(this.bondData.date).format('YYYY-MM-DD')
							});
							setTimeout(() => {
								this.$refs.table.resetInputsFocus();
							})
						})
					}
					if (this.entryId) {
						this.entryId = null;
						this.saveNotes = this.tableInputs.note;
						const nextRowIndex = this.$refs.table.editNextRow();
						if (nextRowIndex !== -1) {
							this.entryId = this.entries[nextRowIndex].id;
							this.reverseCurrencyPriceInputValue();
							this.$nextTick(() => {
								this.$refs.table.scrollToRow();
								setTimeout(() => {
									this.$refs.table.resetInputsFocus();
								})
							})
						} else {
							initTable();
						}
					} else {
						initTable();
					}
					
					// this.$nextTick(() => {
					// 	this.$refs.table.resetInputsFocus();

					// })
				})
			})
			.finally(()=>{

				this.loading = false;
				this.$nextTick(() => {
					// this.$refs.table.$refs[`input_1`][0].$children[0].$refs.BeeNumericField.focus();
				})
				// this.$refs.table.loading = false;
			})
		}
	},
	goToAccountStatement(entry){
		this.$router.push({ name: 'statement', params: { id: entry.account_id } })
	},
	posting(){
		this.updateBondLoading = true;
		this.loading = true;
		this.$store.dispatch('statements/fetchBoxBalanceByNo', { bondNo: this.bond_no }).then((data) => {
			this.$refs.table.resetEdit();
			this.revolvingBalance = data.data
		})	
		store.dispatch("bonds/updateToPosted", { bondId:this.bond.id, bondType: bondType.cash }).then(()=>{
			this.fetchBond().then(() => {
				store.dispatch("configs/fetchAll")
			});
			// Promise.all([store.dispatch("configs/fetchAll"),
			// 	store.dispatch("bonds/fetch", {bondId: this.bond.id, bondType: bondType.cash }),
			// 	store.dispatch("statements/fetchBoxBalance")
			// ]).finally(() => {
			// 	this.updateBondLoading = false;
			// });
		}).catch(() => {
			this.loading = true;
			this.updateBondLoading = false;
		})
	},
	unPosting(){
		this.updateBondLoading = true;
		this.loading = true;
		store.dispatch("bonds/updateToNonPosted", { bondId:this.bond.id, bondType: bondType.cash }).then( ()=>{
			// Promise.all([store.dispatch("configs/fetchAll"),
			// 	store.dispatch("bonds/fetch", {bondId: this.bond.id, bondType: bondType.cash }),
			// 	store.dispatch("statements/fetchBoxBalance")
			// ]).finally(() => {
			// 	this.updateBondLoading = false;
			// });
			this.fetchBond().then(() => {
				store.dispatch("configs/fetchAll")
			})

		}).catch(() => {
			this.loading = false;
			this.updateBondLoading = false;
		})
	},
	changeSumDifferenceEquivalent(toCurrencyId) {
		if(toCurrencyId)
		{
			if(this.sum_difference?.amount)
			{
				let amount = this.sum_difference.amount
				let fromCurrecyId = this.sum_difference.currency_id
				store.dispatch("currencies/exchangeToCurrency",{ toCurrencyId, amount, fromCurrecyId })
					.then(response => {
						_.set(this.sum_difference_equivalent,"amount", response.amount)
						_.set(this.sum_difference_equivalent,"currency_id", response.currency_id)
						_.set(this.sum_difference_equivalent,"money_type", this.sum_difference_equivalent_api?.money_type)
					})
			}
		}
	},
	statementAccount(){
		let box_id = this.configs?.accounts?.find(c=>c.is_box)?.id
		if(box_id)
			this.$router.push({ name: "statement", params: { id: box_id } }).catch(()=>{})
	},
	fetchEntry(entry){
		return store.dispatch("bonds/fetchEntry",{ id: entry.id})
	},
    // handlBlurBoundTable(entry) {
    // 	this.messagesSelectRowValidation = entryCashDetectedValidation(entry,this.linkedBoundRules);
    // },
	async createAccount(){
		this.showAccountForm = true
		await store.dispatch("customStatements/fetchAll")
	},
	checkMainBox(){
		if(typeof this.main_box === 'string' && this.main_box.length === 0){
			this.alertNoBoxAccountDialog = true
		}
	},
	openAccountStatement({ item }) {
		if (openNewWindowForAccountStatement) {
			window.open(this.$router.resolve({ name: 'statement', params: { id: item.account_id } }).href, '_blank');
		} else {
			const route = this.$router.resolve({ 
				name: 'statement', 
				params: { id: item.account_id }
			});
			window.open(route.href, '_blank');
		}
	},
	changeRoute() {
		const bond = this.simplified_bonds?.find(c=>c.bond_no == this.bond_no);
		this.$router.push({name: 'cash-journal', params: {id: bond.id}})
	},
	paymentReceiptBond(entry) {
		this.$store.dispatch('reports/paymentReceiptBond', {	
            financialFileId: this.currentFinancialFile.id,
            userId: ls.getLocalUser().id,
			entryIds: [entry.id],
			subBondType: entry.credit ? paymentReceiptBondType.receipt : paymentReceiptBondType.payment,
			type: 'pdf',
		})
	}

},
mounted() {
	this.loading = false;
	window.observer.observe(document.querySelector("#tool-bar"))
	window.observer.observe(document.querySelector("#footer"))
	this.reverseCurrencyPrice = this.defaultReversedCurrencyPrice;
	this.checkMainBox();

	!this.users.length ? this.$store.dispatch('users/fetchAll') : null
		let promises = []
		
	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch("configs/fetchAll"))

	let bonds = JSON.parse(JSON.stringify(store.state.bonds.simplified_cash_bonds))
	if(bonds.length == 0)
		promises.push(store.dispatch("bonds/fetchAll", { bondType: bondType.cash }))
		
	Promise.all(promises).then(() => {
		// if(to.params.id)
		// {
		// 	if(to.name != 'cash-journal')
		// 	{
		// 		store.dispatch("accounts/getMainBox").then(response => {
		// 			if(!!response)
		// 				store.dispatch("statements/fetchBoxBalance")
		// 		})
					
		// 		next({name: 'cash-journal', params:{id: to.params.id}})
		// 	}	
		// }	
		// else
		// {
		// 	bonds = JSON.parse(JSON.stringify(store.state.bonds.simplified_cash_bonds))
		// 	if(bonds.length > 0) 
		// 		next({ name: 'cash-journal', params:{id: bonds[bonds.length -1].id }})
		// 	else
		// 	{
		// 		store.dispatch("accounts/getMainBox").then(response => {
		// 			if(!!response)
		// 				store.dispatch("statements/fetchBoxBalance")
		// 		})
		// 	}
				
		// }
		if(this.$route.params.id)
		{	
			// vm.$refs.table.openLoading();
			this.fetchBond()
				// .then(() => { 
				// 	// store.dispatch('statements/fetchBoxBalanceByNo', { bondNo: response.bond_no }).then((data) => {
				// 	// 	this.revolvingBalance = data.data
				// 	// }),

				// 	// vm.bond_no = response.bond_no;
				// 	// vm.bondData.date = response.date;
				// 	// vm.bondData.notes = response.notes;
				// 	// vm.$refs.table.endLineInputValues = {date: new Date().toISOString()},
				// 	// vm.$refs.table.onEsc(),
				// 	// vm.$refs.table.closeLoading();
				// })
		} else {
			bonds = JSON.parse(JSON.stringify(store.state.bonds.simplified_cash_bonds))
			if(bonds.length > 0) 
			{
				this.$router.push({ name: 'cash-journal', params:{id: bonds[bonds.length -1].id }})
			}
			else
			{
				store.dispatch("accounts/getMainBox").then(response => {
					if(!!response)
						store.dispatch("statements/fetchBoxBalance")
				})
			}
		}
	})

},
watch: {
	$route: function (to, from) {
		this.sum_difference_equivalent = { amount: null, currency_id: null, money_type: null}
		// if(to.params.id != this.simplified_bonds?.find(c=>c.bond_no == this.bond_no)?.id || (from.name == "cash-journal" && to.name == 'cash-journal'))
		// {	
		// 	if(to.params.id)
		// 	{
		// 		// this.$refs.table.openLoading();
		// 		// store.dispatch("bonds/fetch", {bondId: to.params.id, bondType: bondType.cash })
		// 		// 	.then(response=> { 
		// 		// 		store.dispatch("statements/fetchBoxBalance")
		// 		// 		this.bond_no = response.bond_no;
		// 		// 		this.bondData.date = response.date
		// 		// 		this.bondData.notes = response.notes;
		// 		// 		// this.$refs.table.endLineInputValues = {date: new Date().toISOString()},
		// 		// 		// // this.$refs.table.onEsc(),
		// 		// 		// this.$refs.table.closeLoading();
		// 		// 		})
		// 		this.fetchBond();
		// 	} else {
		// 		this.$router.go(0);
		// 	}
		// }
		this.$refs.table.resetEdit();
		if(to.params.id) {
			this.fetchBond()
		} else if(from.params.id && this.simplified_bonds.find(v => v.id === +from.params.id)) {
			this.$router.push({name: 'cash-journal', params: {id: from.params.id}});
		}
	},
	main_box(){
		this.checkMainBox();
	},
	'defaultReversedCurrencyPrice'(val) {
		this.reverseCurrencyPrice = val;
	},
	'tableInputs.date'(val) {
		if(!val) {
			this.tableInputs.date = moment(this.bondData.date).format('YYYY-MM-DD');
		}
	},
	'tableInputs.note'(newVal) {
		if (!this.entryId) {
			this.saveNotes = newVal;
		}
	},
},
  computed: {
	...mapState("configs" , ["configs"]),
	...mapState({ simplified_bonds: (state) => state.bonds.simplified_cash_bonds }),
	...mapState("statements" , ["box_balance"]),
	...mapState("accounts" , ["main_box"]),
	/*Avoid sharing bond store data when starting a new financial file, if it hasn't had cash bonds yet.*/
	// ...mapState({ cashBond: (state) => state.bonds.bond }),
	...mapState({
		canUnPost: state => state.permissions.selfPermissions.canUnPost,
		users: state => state.users.users,
		currentFinancialFile: state => state.financialFiles.current_financial_file,
		userType: state => state.permissions.user_type,
	}),
	...mapGetters({
		getCurrencyById: 'configs/getCurrencyById',
		getUserById: 'users/getUserById',
		getAccountById: 'configs/getAccountById',
		isViewer: 'permissions/isViewer',
		getSettingByKey: 'settings/getSettingByKey'
	}),
	headers(){
		const headers = [
			{
				text: '#',
				value: 'order_inside_bond',
				type: 'string',
				noInput: true,
				width: '2%',
				editable: false
			},
			{
				text: this.$t('CashJournalPage.headers.credit'),
				value: 'credit.amount',
				name: 'credit',
				type: 'number-format',
				width: '10%',
				editable: true, 
				inputRules: (() => {
						if (this.inputsValidations.debit) return [];
						else return [() => false];
					})(),
			},
			{
				text: this.$t('CashJournalPage.headers.debit'),
				value: 'debit.amount',
				name: 'debit',
				type: 'number-format',
				width: '10%',
				editable: true, 					
				inputRules: (() => {
						if (this.inputsValidations.credit) return [];
						else return [() => false];
					})(),
			},
			{
				text: this.$t('CashJournalPage.headers.account'),
				value: 'account_id',
				name: 'account',
				setValueExpr: val => {
					const account = this.getAccountById(val);
					return `${account?.accounting_no}-${account?.name}`
				},
				width: '18%',
				editable: true, settings: { },  
				inputRules: [this.rules.required] 
			},
			{
				text: this.$t('CashJournalPage.headers.note'),
				value: 'note',
				name: 'note',
				type: 'string',
				width: '15%',
				editable: true
			},
			{
				text: this.$t('CashJournalPage.headers.currency'),
				value: 'currency_id',
				name: 'currency',
				setValueExpr: (value) => (this.getCurrencyById(value) || {}).symbol,
				// type: 'currencies-autocomplete',
				width: '5%',
			},
			{
				text: this.$t('CashJournalPage.headers.currency-credit'),
				value: 'currency_credit.amount',
				name: 'currency-credit',
				type: 'number-format',
				width: '10%',
				inputRules: (() => {
					if (this.inputsValidations['currency-credit']) return [];
					else return [() => false]
				})(),
				setInputExpr: (inputs, activeInput) => {
					let price = this.reverseCurrencyPrice
										? (inputs['currency-price']? 1 / (inputs['currency-price']) : 0) 
										: inputs['currency-price'];
					if (activeInput !== 'currency-credit') {
						if (inputs.currency > 0 && inputs.credit && price) {
							this.tableInputs['currency-credit'] = inputs.credit / (price);
						} 
						else if (inputs['currency-credit'] && inputs['credit']) {
							this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																	? inputs['currency-credit'] / inputs['credit'] 
																	: inputs['credit'] / inputs['currency-credit'] ;
						}
						else {
							return 0;
						}
					} else {
							if (!inputs['currency-debit']) {
								const newVal = inputs['currency-credit'] 
										? inputs.credit / inputs['currency-credit']
										: 0;
								
								this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																			? (newVal 
																				? 1 / (newVal) 
																				: inputs['currency-price'] 
																					? 1 / inputs['currency-price'] 
																					: 0
																			) 
																			: newVal || inputs['currency-price'];
								if(this.reverseCurrencyPrice && inputs['currency-price']) {

									this.tableInputs.credit = (1 / inputs['currency-price']) *  inputs['currency-credit']
									
								} else {
										this.tableInputs.credit =
											inputs['currency-price']* inputs['currency-credit'];
								}
							}
					}
					return inputs['currency-credit'];
				},

			},
			{
				text: this.$t('CashJournalPage.headers.currency-debit'),
				value: 'currency_debit.amount',
				name: 'currency-debit',
				type: 'number-format',
				width: '10%',
				inputRules: (() => {
					if (this.inputsValidations['currency-debit']) return [];
					else return [() => false]
				})(),
				setInputExpr: (inputs, activeInput) => {
					let price = this.reverseCurrencyPrice
										? (inputs['currency-price'] ? 1 / (inputs['currency-price']) : 0) 
										: inputs['currency-price'];
					if (activeInput !== 'currency-debit') {
						if (inputs.currency > 0 && inputs.debit && price) {
							this.tableInputs['currency-debit'] = inputs.debit / (price);
						} 
						else if (inputs['currency-debit'] && inputs['debit']) {
							this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																	? inputs['currency-debit'] / inputs['debit'] 
																	: inputs['debit'] / inputs['currency-debit'] ;
						}
						else {
							return 0;
						}
					} else {
						if (!inputs['currency-credit']) {
							const newVal = (inputs['currency-debit'] 
								? inputs.debit / inputs['currency-debit']
								: 0);
							
							this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																		? (newVal 
																			? 1 / (newVal) 
																			: inputs['currency-price'] 
																				? 1 / inputs['currency-price'] 
																				: 0
																		) 
																		: newVal || inputs['currency-price'];
							if(this.reverseCurrencyPrice && inputs['currency-price']) {

								this.tableInputs.debit = (1 / inputs['currency-price']) *  inputs['currency-debit']

							} else {
									this.tableInputs.debit =
										inputs['currency-price']* inputs['currency-debit'];
							}
						}
					}
					return inputs['currency-debit'];
				}
			},
			{
				text: this.$t('CashJournalPage.headers.price'),
				value: 'currency_price',
				name: 'currency-price',
				type: 'number',
				width: '7%',
				inputRules: (() => {
					if (this.inputsValidations['currency-price']) return [];
					else return [() => false];
				})(),
				setValueExpr: v => (this.reverseCurrencyPrice && v > 0 )? (1 / v) : v,
				setInputExpr: (inputs, activeInput) => {
					if (activeInput === 'currency-price') {
						const price = this.reverseCurrencyPrice
								? 1 / (inputs['currency-price'] || 1) 
								: inputs['currency-price'];
						if (inputs.currency > 0) {
							if (inputs.debit && inputs['currency-debit']) {
								this.tableInputs.debit = price * inputs['currency-debit'];
							} else if (inputs.credit && inputs['currency-credit']) {
								this.tableInputs.credit = price * inputs['currency-credit'];
							}
						}
					}
					return inputs['currency-price'];
				}
			},
			{
				text: this.$t('CashJournalPage.headers.paper-document-no'),
				name: 'paper-document-no',
				value: 'paper_document_no',
				type: 'string',
				width: '5%',
				editable: true
			},
			this.showDateEntryColumn ? {
				text: this.$t('AccountingJournalPage.headers.date'),
				name: 'date',
				value: 'date',
				type: 'date',
				// FIXME after replacing `bee-date-field` with `bee-date-input` you need format to be "DD-MM-YYYY"
				dateFormat: 'YYYY-MM-DD',
				// 	width: 170,
				width: 120,
				inputRules: [this.rules.required]
			} : null,
			{
				text: '',
				name: 'hint',
				value: 'hint',
				width: '30px',
				cellClass: 'px-1',
				noNotAvailableText: true,
				divider: false,
				editable: false,
				noInput: true
			},
		];
		// console.log(this.showDateEntryColumn)
		return headers.filter(v => Boolean(v));
	},
	bond(){
		return this.$route.params.id ? this.cashBond : {}
	},
    entries(){
		return this.bond.entries || []
	},
	addable(){
		return this.bond.is_posted || !this.bond_no ? false : true
	},
	/** **/
	file_is_locked(){
        return this.configs?.financial_file?.is_locked },
	on_mdAndUp(){
		if(this.$vuetify.breakpoint.mdAndUp)
			return true
		return false;
	},
	sum_debits(){return this.bond?.statement_summary?.sum_result?.sum_debits || null},
	sum_credits(){return this.bond?.statement_summary?.sum_result?.sum_credits || null},
	sum_difference(){return this.bond?.statement_summary?.sum_result?.sum_difference || null},
	sum_difference_equivalent_api(){return this.bond?.statement_summary?.sum_result?.sum_difference_equivalent || null},
	on_lgAndUp(){
		if(this.$vuetify.breakpoint.lgAndUp)
			return true
		return false;
	},

	currency_debits(){return this.bond?.statement_summary?.sum_currencies_result?.currency_debits || null},

	// currency_debits(){return this.bond?.statement_summary?.sum_currencies_result?.currency_debits.map(c => `${c.amount.toLocaleString('en')}   ${this.getCurrencyById(c.currency_id).symbol}`) || null},

	currency_credits(){return this.bond?.statement_summary?.sum_currencies_result?.currency_credits || null},

	// currency_credits(){return this.bond?.statement_summary?.sum_currencies_result?.currency_credits.map(c => `${c.amount.toLocaleString('en')}   ${this.getCurrencyById(c.currency_id).symbol}`) || null},

	currencies_sum_difference() {
		return (
			// .map(c => c.amount.toLocaleString('en'))
			// .map(c => `${c.amount}${c.money_type}${c.currency_id}`).join('')
			
			// this.bond?.statement_summary?.sum_currencies_result?.currencies_sum_difference.map(c => `${c.amount.toLocaleString('en')}   ${this.getCurrencyById(c.currency_id).symbol}`) || 
			this.bond?.statement_summary?.sum_currencies_result?.currencies_sum_difference || 
			null
		)
	},
	create_bonds_manually(){return ls.getAskBeforeBondCreation()},
	show_symbol_currencies(){return ls.getVisibleSymbolMoney()},
	bond_posting_ratio_tooltip(){return this.configs?.num_of_not_posted_bonds ? `${this.configs.num_of_not_posted_bonds} ${this.$t('CashJournalPage.not-posted-bonds')} ` : this.$t('CashJournalPage.all-bonds-are-posted') },
	bond_posting_ratio(){return this.configs?.num_of_total_bonds ?   100-(this.configs.num_of_not_posted_bonds*100)/this.configs.num_of_total_bonds : 100  },
	bond_posting_ratio_caption(){ return `${this.configs?.num_of_not_posted_bonds}/${this.configs?.num_of_total_bonds}`},
	custom_configs(){return {...this.configs, accounts : this.configs.accounts ? this.configs.accounts.filter(c=>c.type == 2 && !c.is_box) : [], currencies: this.configs.currencies? this.configs.currencies.filter(c=>c.id != this.configs.financial_file.default_currency_id): []}},
	actionsList(){
		return [
			{
				name: "account-statement",
				disabled: false,
				action_name: actions.GET,
				text: this.$t('CashJournalPage.context-menu.account-statement')
			},
			{
				name: "edit",
				disabled: this.bond.is_posted,
				action_name: actions.EDIT,
				text: this.$t('CashJournalPage.context-menu.edit')
			},
			{
				name: "delete-item",
				disabled: this.bond.is_posted,
				action_name: actions.DELETE,
				text: this.$t('CashJournalPage.context-menu.delete')
			}
		]
	},
	contextmenuItems(){
		const items = [
			this.userType !== this.userPermission.treasurer ?
				{
					title: this.$t('AccountingJournalPage.context-menu.account-statement'),
					event: 'account-statement',
					class: 'text-h6'
				} 
				: null,
			{
				title: this.$t('AccountingJournalPage.context-menu.edit'),
				event:'edit',
				disabled: this.bond.is_posted || this.file_is_locked,
				class: 'text-h6'
			},
			{
				title: this.$t('AccountingJournalPage.context-menu.delete'),
				event: 'delete',
				disabled: this.bond.is_posted || this.file_is_locked,
				class: 'text-h6'
			}
		]

		return items.filter(Boolean)
	},
	infoHeaders() {
		const headers = [
			{
				text: this.$t('invoice-headers.action'),
				value: 'type',
				name: 'type',
				sortable: false
			},
			{
				text: this.$t('invoice-headers.date-formatted'),
				value: 'date_formatted',
				name: 'date',
				sortable: false
			},
			{
				text: this.$t('invoice-headers.user'),
				value: 'user_id',
				setValueExpr: value => this.getUserById(value)?.user_name,
				name: 'userName',
				sortable: false
			}
		]
		return headers
	},
	inputsValidations() {
		const inputs = this.tableInputs;
		return {
			debit: 
				(inputs['debit'] > 0 && !inputs['credit']) || (!inputs['debit'] && inputs['credit'] > 0),
			credit:
				(inputs['credit'] > 0 && !inputs['debit']) || (!inputs['credit'] && inputs['debit'] > 0),
			'currency-debit': 
				(!inputs['currency-debit'] && !inputs.currency) ||
				(inputs['currency-debit'] > 0 && inputs.currency > 0 && !inputs['credit']) ||
				(!inputs['currency-debit'] && inputs['currency-credit'] > 0 && inputs.currency > 0 && !inputs['debit']),
			'currency-credit': 
				(!inputs['currency-credit'] && !inputs.currency) ||
				(inputs['currency-credit'] > 0 && inputs.currency > 0 && !inputs['debit']) ||
				(!inputs['currency-credit'] && inputs['currency-debit'] > 0 && inputs.currency > 0 && !inputs['credit']),
			'currency-price':
				(!inputs.currency && !inputs['currency-price']) ||
				(inputs.currency && inputs['currency-price'])
		}
	},
	inputsValidationMessages() {
		const messages = [];
		const inputs = this.tableInputs;
		if (!inputs.debit && !inputs.credit) {
			messages.push(this.$t('table-messages.cash-debit-and-credit-required'))
		}
		if (inputs.debit && inputs.credit) {
			messages.push(this.$t('table-messages.cash-debit-and-credit-one-of'));
		}

		if (!inputs.account) {
			messages.push(this.$t('table-messages.account-required'));
		}
		
		if (!inputs.currency && (inputs['currency-debit'] || inputs['currency-credit'])) {
			messages.push(this.$t('table-messages.no-currency-debit-and-credit-without-currency'));
		}
		if (inputs.currency > 0 && !inputs['currency-debit'] && !inputs['currency-credit']) {
			messages.push(this.$t('table-messages.currency-debit-and-credit-required'));
		}
		if (inputs.debit && inputs['currency-credit']) {
			messages.push(this.$t('table-messages.debit-with-currency-debit-relation'));
		}
		if (inputs.credit && inputs['currency-debit']) {
			messages.push(this.$t('table-messages.credit-with-currency-credit-relation'));
		}

		if (inputs.currency > 0 && !inputs['currency-price']) {
			messages.push(this.$t('table-messages.currency-price-required'));
		}
		if (!inputs.currency && inputs['currency-price']) {
			messages.push(this.$t('table-messages.currency-required'));
		}

		// FIXME after replacing `bee-date-field` with `bee-date-input` you only need "!inputs.date" condition
		if ((!inputs.date || this.validationMessages.includes('invalid-input-date'))&& this.showDateEntryColumn) {
			messages.push(this.$t('table-messages.date-required'));
		}
		return messages
	},
	showDateEntryColumn() {
		return this.getSettingByKey('ShowDateEntry')?.setting_value;
	},
	canAddFutureDate() {
		return this.getSettingByKey('CanAddFutureDate')?.setting_value;
	},
	defaultReversedCurrencyPrice() {
		return this.getSettingByKey('ReverseCurrencyPrice')?.setting_value;
	},
	advancedColorMode() {
		return this.getSettingByKey('ProfessionalAccountingColorMode')?.setting_value;
	},
	hideDeleteButton() {
		return this.getSettingByKey('hideDeleteBondButton')?.setting_value;
	},
	useExportPaymentReceiptBond() {
        return this.getSettingByKey('useExportPaymentReceiptBond')?.setting_value
    }
 },
beforeDestroy() {
	this.$store.dispatch('bonds/clearBond')
},
// async beforeRouteEnter(to, from, next) {
// 	if(from.name == "cash-journal" && to.name == "cash-journal")
// 	next(
// 		vm => {
// 		if(to.name == "cash-journal")
// 		{

					
//         }})
// }
};
</script>
<style scoped>

/* first part of the footer */ 
.custom_debit_credit_styles {
	width: 145px;
	height: 30px;
}
.custom_sum_difference_styles {
	width: 290px;
	height: 30px;
}

/* second part of the footer */ 
.custom_revolvingBalance_sum_result_styles {
	width: 155px;
	height: 30px;
}

/* last part of the footer */ 
.custom_currencies_maring {
	margin-right: 44px;
}

.custom_2 {
	margin-right: 15px;
}

.custom_revolving_box {
	border: 3px solid rgb(128, 128, 129);
	border-radius: 10px;
}

.border_text_revolving {
	width: 45px;
    position: relative;
    top: -28px; /* Adjust to align within the border */
    background-color: #f2f2f2; /* Match the box color to blend */
    padding: 0 5px;
    font-weight: bold;
    color: rgb(102, 102, 102);
	user-select: none;
    pointer-events: none;
}


/* ============= */
/* media queries */
/* ============= */
@media (max-width: 1368px) {
	/* first part of the footer */ 
	.custom_debit_credit_styles {
		width: 123px;
		height: 30px;
	}
	.custom_sum_difference_styles {
		width: 246px;
		height: 30px;
	}

	/* second part of the footer */ 
	.custom_revolvingBalance_sum_result_styles {
		width: 130px;
		height: 30px;
	}

	/* last part of the footer */ 
	.custom_currencies_maring {
		margin-right: 0px;
	}
	/*.custom_1 {
		padding-right: 0px;
	}*/
	.custom_2 {
		margin-right: 12px
	}
}





.medium-placeholder .v-label {
  	font-size: 0.7rem !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;	
}
.colored-border {
  	border-right: #D39A38 !important;
}
</style>
<style>
.v-bottom-navigation {
	overflow-y: unset;
	box-shadow: 0px 10px 5px #eee, 0px -2px 5px gainsboro !important;
	background: linear-gradient(180deg, rgba(241,241,241,1) 0%, rgba(230,240,245,1) 100%);
}
</style>